import React, { Component } from "react";
import { SideBar, NavBar } from "../../components";
require("dotenv").config();

class Programacao extends Component {
  constructor() {
    super();

    this.state = {
      dtini: localStorage.getItem("dtini"),
      dtfim: localStorage.getItem("dtfim"),
      descProgramacao: localStorage.getItem("descProgramacao"),
      idProgramacao: localStorage.getItem("idProgramacao"),
      actionPage: localStorage.getItem("actionPage"),
      descProgramacao: localStorage.getItem("descProgramacao"),
      idIntegracaoVendedor: localStorage.getItem("idIntegracaoVendedor"),
      idUsuario: localStorage.getItem("idUsuario")
    };
  }

  render() {
    return (
      <div className="container-scroller font-app">
        <NavBar title="Programação" />
        <div className="container-fluid page-body-wrapper">
          <SideBar itemActive={"programacao"} />
          <div className="main-panel" style={{height: "calc(100vh - 60px)"}}>
            <iframe
              src={`${
                process.env.REACT_APP_DEV_PROGRAMACAO_URL
              }?valor=true&dtini=${this.state.dtini}&dtfim=${
                this.state.dtfim
              }&idprogramacao=${this.state.idProgramacao}&actionpage=${
                this.state.actionPage
              }&idintegracaovendedor=${
                this.state.idIntegracaoVendedor
              }&idusuario=${
                this.state.idUsuario
              }&descprogramacao=${encodeURIComponent(
                this.state.descProgramacao
              )}`}
              title="Programação"
              height="800px"
            ></iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default Programacao;
